// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as VehicleType from "../types/vehicle-specific/VehicleType.bs.js";
import * as ContentTypes from "../../../../common/types/ContentTypes.bs.js";
import * as VehicleOmsApiModel from "../api-model/VehicleOmsApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function get_vehicle_fleet(vehicle_fleet) {
  return List.map((function (fleet) {
                return {
                        name: VehicleType.fromString(fleet.vehicle_type),
                        display_name: fleet.display_name,
                        capacity: fleet.capacity_display,
                        base_fare: fleet.base_fare_display,
                        size: fleet.size_display,
                        featured_img: {
                          path: ContentTypes.createUrl(fleet.image_url),
                          alt_text: fleet.image_alt_text
                        },
                        icon: {
                          path: ContentTypes.createUrl(fleet.vehicle_icon_url),
                          alt_text: fleet.image_alt_text
                        },
                        fare_instruction: fleet.free_time_distance_text
                      };
              }), vehicle_fleet);
}

function apiModelToState(model) {
  return {
          vehicle: Belt_Option.mapWithDefault(model.fleet_list, /* [] */0, get_vehicle_fleet)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(VehicleOmsApiModel.t_decode(json), "VehicleOmsEntityMapper.res"));
}

export {
  get_vehicle_fleet ,
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
